// extracted by mini-css-extract-plugin
export default {"BranchNameInput-prefix":"BranchNameInput-prefix2Vva-zbD8BKd"};